<div class="w-full" [formGroup]="formGroup">
    @if(slot.label){
    <label class="text-[14px] font-medium text-foreground opacity-80 flex block mb-2">{{ slot.label }}</label>
    }
    <z-date-picker
        [value]="getValue()"
        [placeholder]="slot.placeholder"
        (dateChange)="onDateChange($event)"
        zSize="sm"
        class="w-full text-[10px]"
    ></z-date-picker>
</div>
